"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenderedComponent = exports.simplifyChildren = exports.flattenChildren = exports.arePropsEqual = exports.deepEqual = void 0;
var deep_equal_1 = __importDefault(require("deep-equal"));
var react_1 = __importDefault(require("react"));
var TypeGuards = __importStar(require("./typeGuards"));
exports.deepEqual = deep_equal_1.default;
function arePropsEqual(previous, next, options) {
    var e_1, _a, e_2, _b;
    var check = options.check, _c = options.excludeKeys, excludeKeys = _c === void 0 ? [] : _c, debug = options.debug;
    try {
        for (var check_1 = __values(check), check_1_1 = check_1.next(); !check_1_1.done; check_1_1 = check_1.next()) {
            var c = check_1_1.value;
            var nextItem = next[c];
            var prevItem = previous[c];
            try {
                for (var excludeKeys_1 = (e_2 = void 0, __values(excludeKeys)), excludeKeys_1_1 = excludeKeys_1.next(); !excludeKeys_1_1.done; excludeKeys_1_1 = excludeKeys_1.next()) {
                    var key = excludeKeys_1_1.value;
                    if (nextItem === null || nextItem === void 0 ? void 0 : nextItem[key])
                        delete nextItem[key];
                    if (prevItem === null || prevItem === void 0 ? void 0 : prevItem[key])
                        delete prevItem[key];
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (excludeKeys_1_1 && !excludeKeys_1_1.done && (_b = excludeKeys_1.return)) _b.call(excludeKeys_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            var propsAreEqual = (0, deep_equal_1.default)(nextItem, prevItem);
            if (!propsAreEqual) {
                var logArgs = [
                    'Props not equal',
                    { item: c, nextItem: nextItem, prevItem: prevItem, previous: previous, next: next, check: check },
                    'arePropsEqual',
                ];
                if (debug)
                    console.log.apply(console, __spreadArray([], __read(logArgs), false));
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (check_1_1 && !check_1_1.done && (_a = check_1.return)) _a.call(check_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}
exports.arePropsEqual = arePropsEqual;
var flattenChildren = function (children, flat) {
    if (flat === void 0) { flat = []; }
    flat = __spreadArray(__spreadArray([], __read(flat), false), __read(react_1.default.Children.toArray(children)), false);
    if (children.props && children.props.children) {
        return (0, exports.flattenChildren)(children.props.children, flat);
    }
    return flat;
};
exports.flattenChildren = flattenChildren;
var simplifyChildren = function (children) {
    var flat = (0, exports.flattenChildren)(children);
    return flat.map(function (_a) {
        var key = _a.key, ref = _a.ref, type = _a.type, _b = _a.props, children = _b.children, props = __rest(_b, ["children"]);
        return ({
            key: key,
            ref: ref,
            type: type,
            props: props,
        });
    });
};
exports.simplifyChildren = simplifyChildren;
function getRenderedComponent(ComponentOrProps, DefaultComponent, props) {
    if (TypeGuards.isNil(ComponentOrProps) || Object.keys(ComponentOrProps).length === 0) {
        return null;
    }
    if (TypeGuards.isFunction(ComponentOrProps)) {
        return react_1.default.createElement(ComponentOrProps, __assign({}, props));
    }
    if (react_1.default.isValidElement(ComponentOrProps)) {
        return ComponentOrProps;
    }
    var _props = ComponentOrProps;
    return react_1.default.createElement(DefaultComponent, __assign({}, props, _props));
}
exports.getRenderedComponent = getRenderedComponent;
